/**
 * Theme Toggle Component
 * Sprint 31.7: Updated to use CSS classes from index.css (no Tailwind).
 *
 * Provides a button to toggle between light, dark, and system themes.
 */
import { useThemeStore } from '../../stores/themeStore';

interface ThemeToggleProps {
  /** Show label text */
  showLabel?: boolean;
  /** Compact mode for header */
  compact?: boolean;
}

export function ThemeToggle({ showLabel = false, compact = false }: ThemeToggleProps) {
  const { mode, resolved, setMode, toggle } = useThemeStore();

  // Simple toggle button (compact mode)
  if (compact) {
    return (
      <button
        onClick={toggle}
        className="theme-toggle-compact"
        aria-label={`Switch to ${resolved === 'light' ? 'dark' : 'light'} mode`}
        title={`Switch to ${resolved === 'light' ? 'dark' : 'light'} mode`}
      >
        {resolved === 'light' ? (
          // Moon icon for switching to dark
          <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
          </svg>
        ) : (
          // Sun icon for switching to light
          <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        )}
      </button>
    );
  }

  // Full dropdown selector
  return (
    <div className="theme-toggle-container">
      {showLabel && (
        <span className="theme-toggle-label">Theme:</span>
      )}
      <div style={{ position: 'relative' }}>
        <select
          value={mode}
          onChange={(e) => setMode(e.target.value as 'light' | 'dark' | 'system')}
          className="theme-toggle-select"
          aria-label="Select theme"
        >
          <option value="system">System</option>
          <option value="light">Light</option>
          <option value="dark">Dark</option>
        </select>
      </div>
    </div>
  );
}
